import { useTranslator } from "components/Translator"
import { Wrapper } from "components/Wrapper"
import { Text } from "components/Text"
import { Comments, MapMarkerAlt, PhoneAlt } from "components/Icon"
import { Map, MapboxProvider, MapModal, Marker } from "components/Map"
import { Button } from "components/Button"
import { useZendesk } from "components/ZendeskWidget"

export const Contact = () => {
  const translator = useTranslator()
  const initialViewState = {
    latitude: translator.trans("Contact.latitude", null, "components"),
    longitude: translator.trans("Contact.longitude", null, "components"),
    zoom: 14,
  }

  const zendesk = useZendesk()

  return (
    <section className="bg-primary-lighter py-5 lg:py-10">
      <Wrapper>
        <div className="space-y-4">
          <Text variant="headline3" tag="h2" className="text-primary-dark">
            {translator.trans("Contact.title", null, "components")}
          </Text>
          <Text tag="p">
            {translator.trans("Contact.openingHours", null, "components")}
          </Text>
          <Text tag="p" variant="caption">
            {translator.trans("Contact.caption", null, "components")}
          </Text>
          <div className="grid gap-2 lg:grid-cols-3 lg:gap-4">
            <Button
              href={
                "tel:" + translator.trans("Contact.phone", null, "components")
              }
              iconLeft={<PhoneAlt className="w-4" />}
              variant="outline"
              color="secondary"
            >
              {translator.trans("Contact.phoneNormalized", null, "components")}
            </Button>
            <Button
              iconLeft={<Comments className="w-4" />}
              variant="outline"
              color="secondary"
              disabled={!zendesk.isAvailable}
              onClick={zendesk.activate}
            >
              {translator.trans("Contact.chat", null, "components")}
            </Button>
            <MapboxProvider accessToken={process.env.MAPBOX_ACCESS_TOKEN}>
              <MapModal
                trigger={
                  <Button
                    variant="outline"
                    color="secondary"
                    className="w-full"
                    iconLeft={<MapMarkerAlt className="w-4" />}
                  >
                    {translator.trans("Contact.address", null, "components")}
                  </Button>
                }
                map={
                  <Map initialViewState={initialViewState}>
                    <Marker
                      latitude={initialViewState.latitude}
                      longitude={initialViewState.longitude}
                    />
                  </Map>
                }
                title={""}
              />
            </MapboxProvider>
          </div>
        </div>
      </Wrapper>
    </section>
  )
}
